"use client";
import React from "react";

interface UpgradeButtonProps {
  redirectUrl?: string;
  children: React.ReactNode;
  className?: string;
}

const UpgradeButton: React.FC<UpgradeButtonProps> = ({ redirectUrl, children, className }) => {
  const handleClick = React.useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    if (redirectUrl) {
      const params = new URLSearchParams(window.location.search);
      const redirectParam = params.get("redirect");
      if (redirectParam) {
        localStorage.setItem("postPurchaseRedirectUrl", redirectParam);
      }
      window.location.href = redirectUrl;
    }
  }, [redirectUrl]);

  return (
    <button className={className} onClick={handleClick} type="button">
      {children}
    </button>
  );
};

export default UpgradeButton; 